<template>
  <div>
    <FixedRibbon />
    <no-ssr>
      <Loading :active.sync="isLoading" />
    </no-ssr>
    <Header />
    <FixedBar />
    <ResidentAnnoAlert />
    <MBottomMenu v-if="isMobile" />
    <nuxt />
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  onMounted,
  useStore
} from '@nuxtjs/composition-api'

import Header from '../components/layouts/Header.vue'
import FixedBar from '../components/layouts/FixedBar'
import Banner from '../components/Banner'
import NavMenu from '../components/layouts/NavMenu'
import useDeviceHandler from '../../composables/useDeviceHandler'
import useWebp from '../../composables/useWebp'
import useListeningToRefreshToken from '../../composables/useListeningToRefreshToken'
import useDeviceId from '../../composables/useDeviceId'
import useResizeToDetectMobile from '../../composables/useResizeToDetectMobile'
import usePushNotification from '../../composables/usePushNotification'
import useForceLogoutV2 from '../../composables/useForceLogoutV2'
import ResidentAnnoAlert from '../components/ResidentAnnoAlert'
import useComp from '../../composables/useComp'
import FixedRibbon from '../components/FixedRibbon'
import useCSRLauncher from '../composables/useCSRLauncher'
import useGoTopOnPageChange from '../../composables/useGoTopOnPageChange'
import useFinancialSuccess from '../../composables/useFinancialSuccess'
import MBottomMenu from '../components/layouts/MBottomMenu.vue'

export default defineComponent({
  components: {
    MBottomMenu,
    FixedRibbon,
    Header,
    FixedBar,
    Banner,
    NavMenu,
    ResidentAnnoAlert
  },
  setup(props, context) {
    useDeviceHandler()
    useWebp()
    useListeningToRefreshToken(context)
    useDeviceId()
    useResizeToDetectMobile(context)
    usePushNotification(context)
    useForceLogoutV2(context)
    useCSRLauncher(context)
    useGoTopOnPageChange()
    useFinancialSuccess()

    const store = useStore()

    const isLoading = computed(() => store.state.loadingModule.isLoading)
    const banners = computed(() => store.state.bannerModule.banners)
    const isMobile = computed(() => store.state.isMobile)

    const { compId } = useComp()

    onMounted(() => {
      // antillephone 執照
      if (window.apg_8bce1c58_02d4_4e0d_affa_efeb36261cd2) {
        try {
          window.apg_8bce1c58_02d4_4e0d_affa_efeb36261cd2.init()
        } catch (err) {
          console.error(err)
        }
      }
    })

    return { isLoading, banners, isMobile, compId }
  }
})
</script>
